/* eslint-env browser */

'use strict';

const UgcPhotosWidget = require('./UgcPhotosDesktop.js');
const contextmenu = require('./contextmenu.js');
const { injectContainer } = require('./container.js');

const UgcPhotos = {
  init({ ugcPhotos }, done) {
    injectContainer('ugcPhotos', ugcPhotos, window.UgcPhotos);
    const photoWidget = new UgcPhotosWidget(); // eslint-disable-line no-unused-vars
    contextmenu.disabled('#ugc-photos, #ugc-photos-modal');
    return done();
  },
};

window.UgcPhotos = UgcPhotos;
module.exports = UgcPhotos;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/main.js